module.exports = "pegasus/assets/theme5/gallery-img3.png";